<h2 mat-dialog-title>

  <span *ngIf="selectedMarketingItem.title">{{'COMMON.EDIT' | translate}} - {{selectedMarketingItem.title}}</span>
  <span *ngIf="!selectedMarketingItem.title">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div class="row">
        <div class="col-12">

          <mat-form-field>

            <input matInput
                   type="text"
                   placeholder="{{'MARKETING.ADMIN.TITLE' | translate}}"
                   formControlName="title">

          </mat-form-field>

        </div>

        <div class="col-12">

          <mat-form-field>

            <input matInput
                   type="text"
                   placeholder="{{'MARKETING.ADMIN.DESCRIPTION' | translate}}"
                   formControlName="description">

          </mat-form-field>

        </div>

        <div class="col-12">
          <mat-form-field>
            <mat-select placeholder="Ikon" formControlName="icon">
              <mat-option *ngFor="let icon of matIcons" [value]="icon['matClass']">
               <div class="d-flex flex-row">
                 <mat-icon>{{icon['matClass']}}</mat-icon>
                 <p>{{icon['matClass']}}</p>
               </div>
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>


        <div class="col-6 d-flex">
<!--          <color-chrome-->
<!--            class="m-2"-->
<!--            [color]="selectedMarketingItem.primaryColor || '#5626FB'"-->
<!--            (onChangeComplete)="handlePrimaryColorChanged($event)">-->
<!--          </color-chrome>-->
          <app-marketing-item class="m-2" [marketingItem]="selectedMarketingItem"></app-marketing-item>
        </div>


<!--        <div class="mat-icon-selector">-->
<!--          <div class="row">-->
<!--            <div class="col-12 d-flex flex-row " *ngFor="let icon of matIcons">-->
<!--              <mat-icon>{{icon['matClass']}}</mat-icon>-->
<!--              <p>{{icon['matClass']}}</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
